import React from 'react';
import { Col, Row } from 'react-bootstrap';
import FilterPanel from '@spark/ui-components/components/FilterPanel';
import { filterConfig } from '../config/filterConfig';

const OperacoesFilter = ({
  onApply,
  loading
}) => {
  return <Row>
      <Col md={12}>
        {onApply && <FilterPanel filters={filterConfig} onApply={onApply} title="Filtros de Operações" loading={loading} defaultCollapsed={true} />}
      </Col>
    </Row>;
};

export default OperacoesFilter;
